import { PlusCircle, Upload, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

export function EmptyStateCTA() {
  return (
    <div className="border border-border/60 bg-card/30 p-8 sm:p-12 text-center space-y-6 animate-fade-in">
      <div className="flex flex-col items-center gap-3">
        <div className="w-14 h-14 rounded-full flex items-center justify-center">
          <BookOpen className="w-7 h-7 text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground font-mono tracking-tight">No trades yet</h3>
          <p className="text-sm text-muted-foreground mt-1 max-w-xs mx-auto">
            Log your first trade to unlock your performance dashboard, equity curve, and AI insights.
          </p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/journal"
          className="flex items-center justify-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          <PlusCircle className="w-4 h-4" />
          Log First Trade
        </Link>
        <button
          onClick={() => document.dispatchEvent(new CustomEvent("open-csv-import"))}
          className="flex items-center justify-center gap-2 px-5 py-2.5 border border-border text-foreground text-sm font-medium hover:bg-secondary transition-colors"
        >
          <Upload className="w-4 h-4" />
          Import CSV
        </button>
      </div>
      <p className="text-[11px] text-muted-foreground">Supports MT4, MT5, and Tradovate CSV exports</p>
    </div>
  );
}
